import classNames from 'classnames';
import Skeleton from '@/components/Skeleton';
import styles from './AwaitingSignatures.module.scss';

const SkeletonRow = () => (
  <li className={classNames(styles.row, styles.rowSkeleton)}>
    <Skeleton className={styles.avatarSkeleton} />
    <div className={styles.meta}>
      <Skeleton className={styles.titleSkeleton} />
      <Skeleton className={styles.senderSkeleton} />
    </div>
    <Skeleton className={styles.timeSkeleton} />
    <Skeleton className={styles.deadlineSkeleton} />
    <Skeleton className={styles.ctaSkeleton} />
  </li>
);

export default SkeletonRow;
